import styled from "styled-components";

const ContentContainer = styled.div`
    padding: 55px 50px;
    min-height: 100vh;
`;

export default ContentContainer;
